<fieldset
  class="fieldset"
  [class]="fieldsetClass()"
  [attr.aria-describedby]="ariaDescribedBy()"
  [attr.data-testid]="dataTestId()"
>
  @if (label() || customLegend()) {
    <legend class="fieldset-legend" [class]="legendClass()" [id]="legendId()">
      @if (customLegend()) {
        <ng-content select="[fieldsetLegend]" />
      } @else {
        {{ label() }}
      }
    </legend>
  }

  <ng-content />

  @if (showErrors() && touched()) {
    @for (error of errors(); track error.kind; let first = $first) {
      <p
        class="label text-error"
        role="alert"
        [id]="first ? errorId() : undefined"
        [attr.data-testid]="first ? errorTestId() : undefined"
      >
        {{ error.message }}
      </p>
    }
  }
</fieldset>
